export enum ECurrencies {
  USD = 'USD',
  AUD = 'AUD',
  SGD = 'SGD',
  EUR = 'EUR',
}

export enum ECountries {
  AUSTRALIA = 'Australia',
}

export enum ESortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum EKeyboardKey {
  ENTER = 'enter',
}
